import { size } from '../../lib/utilities';
export class GetParameters {
    constructor() {
        this.getParameterFromUrl();
    }

    getParameterFromUrl() {
        var getParams = {};

        if (location.search !== "") {
            let keyValuePairs = location.search.substr(1, location.search.length - 1).split("&");
            
            keyValuePairs.forEach((keyValuePair) => {
                var key, value, split;
                split = keyValuePair.split('=');
                key = split[0];
                value = split[1] || null;

                getParams[key] = value;
            });
        }
        
        this.GETParams = getParams;
    }

    hasAny() {
        return size(this.GETParams) > 0;
    }
    
    has(name) {
        return (name in this.GETParams);
    }
    
    get(name) {
        return this.GETParams[name];
    }
}

export default GetParameters;
